export default __webpack_public_path__ + "static/listings-acquisitions_300x200-06cc35e9c15915b0fc2b62462e7e04a8.jpg";